/** @jsx _j **/
/** @jsxFrag _f **/

const { jsx: _j, F: _f } = require('astroturf');
import classNames from 'classnames';
import React from 'react';
import SectionTitle from './SectionTitle';

/**
 * A Form `fieldset` component.
 */
function FieldSet({
  legend,
  children,
  className,
  small,
  legendSrOnly
}) {
  return _j("fieldset", {
    className: className,
    css: [require("./FieldSet-CssProp1_fieldset.module.scss"), []]
  }, React.createElement(SectionTitle, {
    as: "legend",
    variant: small ? 'body-bold' : 'lg',
    className: classNames(legendSrOnly && 'sr-only')
  }, legend), children);
}

export default FieldSet;